((app, ng) => {

    app.directive("figDataTableRow",
        [
            "$timeout", "$window", function ($timeout, $window) {
                const directive = {
                    restrict: "EA",
                    link: linkFunc,
                    bindToController: true
                }

                function linkFunc(scope, element) {

                    function resizeCells() {
                        const cells = [...element[0].getElementsByClassName("data-table-cell")];

                        const ngRow = ng.element(element[0]);

                        const rowWidth = ngRow.width();

                        const totalCellWidth = cells.reduce((total, cell) => {
                            const ngCell = ng.element(cell);

                            return total + ngCell.width();
                        },
                            0);

                        if (totalCellWidth < rowWidth) {
                            cells.forEach(cell => {
                                const ngCell = ng.element(cell);

                                ngCell.css("width", rowWidth / cells.length);
                            });
                        }
                    }

                    $timeout(() => {
                        resizeCells();
                    }, 1);

                    ng.element($window).on("resize", resizeCells);

                    scope.$on("$destroy",
                        () => {
                            ng.element($window).off("resize", resizeCells);
                        });
                }

                return directive;
            }
        ]);

})(window.app, window.angular);